import { MTSort, SortDirection } from "@services/getMinerList";

import {
  ActionCleanTableState,
  ActionTypesMinersTable,
  ActionSetPage,
  ActionSetState,
  ActionTempSavePageSize,
  ActionSetSort,
  ActionSetAdminOnlyFlag,
} from "./actionTypes";

export function cleanMinersTableState(): ActionCleanTableState {
  return {
    type: ActionTypesMinersTable.CLEAN_STATE,
  };
}

export function setMinersTablePage(p: number, sz: number): ActionSetPage {
  return {
    type: ActionTypesMinersTable.SET_PAGE,
    payload: { Page: p, PageSize: sz },
  };
}

export function tempSaveMinersTablePageSize(
  sz: number
): ActionTempSavePageSize {
  return {
    type: ActionTypesMinersTable.TEMP_SAVE_PAGE_SIZE,
    payload: sz,
  };
}

export function setMinersTableState(
  page: number,
  pageSize: number
): ActionSetState {
  return {
    type: ActionTypesMinersTable.SET_STATE,
    payload: {
      Page: page,
      PageSize: pageSize,
    },
  };
}

export function setMinersTableSort(
  sort: [MTSort, SortDirection]
): ActionSetSort {
  return {
    type: ActionTypesMinersTable.SET_SORT,
    payload: {
      sort,
    },
  };
}

export function setAdminOnlySummaryChartFlag(payload: boolean): ActionSetAdminOnlyFlag {
  return {
    type: ActionTypesMinersTable.SET_ADMIN_ONLY_SUMMARY_CHART_FLAG,
    payload,
  };
}
